import {useEffect, useState} from "react";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {VehiclePlate} from "../../../models/vehicle-plate";
import instance from "../../index";
import {BaseResponse} from "../../../models/base-response";
import {PagedList} from "../../../models/paged-list";
import {ShortDto} from "../../../models/short-dto";
import {VehiclePlateFilter} from "../../../models/vehicle-plate-filter";
import {UpdateVehiclePlateRequest} from "../../../models/update-vehicle-plate-request";
import {CreateVehiclePlateRequest} from "../../../models/create-vehicle-plate-request";

const useVehiclePlateService= () => {
    const[ loading, setLoading] = useState<boolean>(false);
    const[ vehiclePlateId, setVehiclePlateId] = useState<string>();
    const blockUI = useBlockUI();
    useEffect(() => {
        const vehiclePlateId = localStorage.getItem('vehiclePlateId');
        if (vehiclePlateId) {
            setVehiclePlateId(vehiclePlateId);
        }
    }, []);

    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    async function activateVehiclePlate(id: string): Promise<VehiclePlate> {
        const response = await instance.put<VehiclePlate>(`/v1/backoffice/vehicle-plates/${id}/activate`);
        return response.data;
    }

    async function inactivateVehiclePlate(id: string): Promise<VehiclePlate> {
        const response = await instance.put<VehiclePlate>(`/v1/backoffice/vehicle-plates/${id}/deactivate`);
        return response.data;
    }

    async function deleteVehiclePlate(id: string) {
        const response = await instance.delete(`/v1/backoffice/vehicle-plates/${id}`);
        return response?.data;
    }

    async function getVehiclePlateById(id: string): Promise<VehiclePlate> {
        const response = await instance.get<BaseResponse<VehiclePlate>>(`/v1/backoffice/vehicle-plates/${id}`);
        return response?.data?.data;
    }

    async function getVehiclePlates(filter?: VehiclePlateFilter): Promise<PagedList<VehiclePlate>> {
        const response = await instance.get<PagedList<VehiclePlate>>('/v1/backoffice/vehicle-plates/', {
            params: filter
        });
        return response.data;
    }

    async function getAllVehiclePlatesShortDto(filter?: VehiclePlateFilter): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/vehicle-plates/all', {
            params: filter
        });
        return response?.data?.data;
    }

    async function getAllVehiclePlatesShortDtoFiltered(filter?: VehiclePlateFilter): Promise<ShortDto[]> {
        const response = await instance.get<BaseResponse<ShortDto[]>>('/v1/backoffice/vehicle-plates/all/select', {
            params: filter
        });
        return response?.data?.data;
    }

    async function createVehiclePlate(request: Partial<CreateVehiclePlateRequest>): Promise<VehiclePlate> {
        const response = await instance.post<VehiclePlate>('/v1/backoffice/vehicle-plates/', request);
        return response.data;
    }

    async function editVehiclePlate(request: Partial<UpdateVehiclePlateRequest>, id: string | string[] | undefined): Promise<VehiclePlate> {
        const response = await instance.put<VehiclePlate>(`/v1/backoffice/vehicle-plates/${id}`, request);
        return response.data;
    }

    return {
        loading,
        activateVehiclePlate,
        inactivateVehiclePlate,
        deleteVehiclePlate,
        getVehiclePlateById,
        getVehiclePlates,
        getAllVehiclePlatesShortDto,
        getAllVehiclePlatesShortDtoFiltered,
        createVehiclePlate,
        editVehiclePlate
    }

}

export default useVehiclePlateService;